import { getDay } from "date-fns";
import dayjs from "dayjs";
import { getDateObject } from "../../../utils/DateTimeRepository";
import { isEmptyObject } from "../form/TimeSlots";
//APPEND API DATA HERE, does this return true if day is non working
const isWorkingDay = (date, workingHours, isAdminOrEmployee) => {
  const condition = typeof date == "object";
  var dayMonth;
  if (!condition) {
    dayMonth = dayjs(getDateObject(dayMonth)).format("DD.MM.");
  } else {
    dayMonth = date.format("DD.MM.");
  }

  if (isAdminOrEmployee) {
    return false;
  }

  return isDayNonWorking(date, workingHours);
};

function isDayNonWorking(date, apiDays) {
  const dateFormatted = dayjs(date).format("DD/MM/YYYY");

  const calendarDayName = getDayName(getDay(date.$d));
  const apiDay = apiDays?.find(
    (day) => day.day == String(calendarDayName).toUpperCase()
  );
  const calendarMatch = apiDays?.find((day) => day?.date == dateFormatted);

  if (calendarMatch != undefined && calendarMatch != null) {
    return !calendarMatch?.workingDay;
  }

  return !apiDay?.workingDay;
}

function getDayName(dayIndex) {
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return daysOfWeek[dayIndex].toLowerCase();
}

const checkIfHourAvailable = (hour, bookedHours, userSelectedDate) => {
  if (!userSelectedDate) return true;

  // Is the time in the past? (Only matters if date is Today)
  const isPast = isTimePastToday(hour, userSelectedDate);

  const isBooked = bookedHours?.includes(hour) ?? false;
  return isPast || isBooked;
};

function isTimePastToday(hour, userSelectedDate) {
  const isToday = dayjs(userSelectedDate).isSame(dayjs(), 'day');
  if (!isToday) return false;
  const [hh, mm] = hour.split(":");
  const timeToCompare = dayjs().set('hour', parseInt(hh)).set('minute', parseInt(mm)).set('second', 0);
  
  return dayjs().isAfter(timeToCompare);
}

function getTimeAfter( startTime,availableHours) {
 if (!startTime) return [];
  
  const startDateTime = dayjs(startTime, "HH:mm");
  
  // Filter available slots to only show those that come AFTER the selected start time
  return availableHours.filter(time => {
    const slotTime = dayjs(time, "HH:mm");
    return slotTime.isAfter(startDateTime);
  });
}

export { isWorkingDay, checkIfHourAvailable, getTimeAfter };
